"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.CardModal = exports.CardSection = exports.CardFooter = exports.CardHeader = void 0;
const React = require("react");
const react_native_elevated_view_1 = require("react-native-elevated-view");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const react_native_1 = require("react-native");
class CardHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    padding: 16
                },
                title: {
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 22 : 18,
                    marginRight: 10
                },
                help: {
                    position: 'absolute',
                    right: 5,
                    top: 5
                },
                helpIcon: {
                    fontSize: (0, layout_1.isTablet)() ? 24 : 20,
                    color: '#6d819c'
                }
            });
            return styles;
        };
    }
    render() {
        const { title, titleStyle, onHelpPress, nativeID, containerStyle, numberOfLines } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { nativeID: nativeID, style: [styles.container, containerStyle] },
            React.createElement(react_native_1.Text, { style: [styles.title, titleStyle], numberOfLines: numberOfLines }, title),
            onHelpPress && (React.createElement(react_native_1.TouchableOpacity, { onPress: onHelpPress, style: styles.help },
                React.createElement(FontAwesome_1.default, { name: "question-circle", style: styles.helpIcon })))));
    }
}
exports.CardHeader = CardHeader;
class CardFooter extends React.Component {
    render() {
        const _a = this.props, { children } = _a, otherProps = __rest(_a, ["children"]);
        return (React.createElement(react_native_1.View, Object.assign({ style: [cardFooterStyles.container] }, otherProps), children));
    }
}
exports.CardFooter = CardFooter;
class CardSection extends React.Component {
    render() {
        const _a = this.props, { children, style } = _a, otherProps = __rest(_a, ["children", "style"]);
        return (React.createElement(react_native_1.View, Object.assign({ style: [cardSectionStyles.container, style] }, otherProps), children));
    }
}
exports.CardSection = CardSection;
class CardModal extends React.Component {
    render() {
        const _a = this.props, { children, style } = _a, otherProps = __rest(_a, ["children", "style"]);
        return (React.createElement(react_native_1.TouchableOpacity, Object.assign({ activeOpacity: 1, style: [{ padding: 16 }, style] }, otherProps), children));
    }
}
exports.CardModal = CardModal;
class Card extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    borderRadius: 3,
                    backgroundColor: theme.backgroundColor1,
                    shadowOpacity: 0.15,
                    shadowRadius: 5
                },
                cardChild: {
                    borderTopColor: theme.borderColor1,
                    borderTopWidth: 1
                }
            });
            return styles;
        };
    }
    render() {
        const _a = this.props, { children, style } = _a, otherProps = __rest(_a, ["children", "style"]);
        const styles = this.getStyles();
        const childrenMapped = React.Children.map(children, (child, index) => {
            if (index === 0 || !child) {
                return child;
            }
            return (React.createElement(React.Fragment, null,
                React.createElement(react_native_1.View, { style: styles.cardChild }),
                child));
        });
        return react_native_1.Platform.OS == 'web' ? (React.createElement(react_native_1.View, Object.assign({ style: [styles.container, style] }, otherProps), childrenMapped)) : (React.createElement(react_native_elevated_view_1.default, Object.assign({ elevation: 5, 
            // @ts-ignore : The component uses a different version of typing
            style: [styles.container, style] }, otherProps), childrenMapped));
    }
}
exports.Card = Card;
Card.Header = CardHeader;
Card.Section = CardSection;
Card.Footer = CardFooter;
Card.Modal = CardModal;
const cardSectionStyles = react_native_1.StyleSheet.create({
    container: {
        padding: 16
    }
});
const cardFooterStyles = react_native_1.StyleSheet.create({
    container: {
        padding: 16
    }
});
